import {Stack, Typography} from "@mui/material";
import React, {ReactElement, useEffect, useState} from "react";
import {Celebrity} from "../../common/models/celebrity/celebrity";
import {CelebrityType} from "../../common/enums/celebrityType.enum";
import CelebrityIcon from "../../common/icons/tmb/celebrities/celebrity.icon";
import ActorIcon from "../../common/icons/tmb/celebrities/actor.icon";
import KpopIcon from "../../common/icons/tmb/celebrities/kpop.icon";
import AthleteIcon from "../../common/icons/tmb/celebrities/athlete.icon";
import FictionalIcon from "../../common/icons/tmb/celebrities/fictional.icon";
import SingerIcon from "../../common/icons/tmb/celebrities/singer.icon";
import UserProfilePicture from "../../common/icons/tmb/userProfilePicture";

interface CelebrityOptionProps {
    celebrity: Celebrity;
}

const CelebrityAutocompleteOption = ({celebrity}: CelebrityOptionProps) => {

    const [celebrityImage, setCelebrityImage] = useState<ReactElement>(<></>);

    useEffect(() => {
        if(celebrity.imageUrl)
        {
            setCelebrityImage(
                <img
                    width={42}
                    height={42}
                    style={{ borderRadius: '100%', backgroundSize: 'contain' }}
                    src={celebrity.imageUrl}
                    alt={"Celebrity Image"}
                />
            );
            return;
        }

        switch (celebrity.type) {
            case CelebrityType.CELEBRITY:
                setCelebrityImage(<CelebrityIcon size={42} />);
                break;
            case CelebrityType.ACTOR:
                setCelebrityImage(<ActorIcon size={42} />);
                break;
            case CelebrityType.KPOP:
                setCelebrityImage(<KpopIcon size={42} />);
                break;
            case CelebrityType.ATHLETE:
                setCelebrityImage(<AthleteIcon size={42} />);
                break;
            case CelebrityType.FICTIONAL:
                setCelebrityImage(<FictionalIcon size={42} />);
                break;
            case CelebrityType.SINGER:
                setCelebrityImage(<SingerIcon size={42} />);
                break;
            default:
                setCelebrityImage(<UserProfilePicture size={42} />);
                break;
        }
    }, []);

    return (
        <Stack 
            padding={1}
            width={"100%"} 
            flexDirection={"row"} 
            justifyContent={"space-between"} 
            className={"celebrity-list-item"}
        >
            {celebrityImage}
            <Stack flex={1} flexDirection={"column"} justifyItems={"flex-end"} alignItems={"flex-end"}>
                <Typography>
                    {celebrity.fullName}
                </Typography>
                {celebrity.group
                    ??
                    <Typography fontStyle={"italic"}>
                        {celebrity.group}
                    </Typography>
                }
            </Stack>
        </Stack>
    );
}

export default CelebrityAutocompleteOption